/* eslint-disable import/prefer-default-export */
export const STEPS = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
};
